/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Link_Body_PlainInputs */

const en_signin_link_body_plain = /** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`We sent a sign-in link to your email. Open it on this device.`)
};

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const ar_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const he_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const ur_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const es_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const fr_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const de_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const pt_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const hi_signin_link_body_plain = en_signin_link_body_plain;

/** @type {(inputs: Signin_Link_Body_PlainInputs) => LocalizedString} */
const bn_signin_link_body_plain = en_signin_link_body_plain;

/**
* | output |
* | --- |
* | "We sent a sign-in link to your email. Open it on this device." |
*
* @param {Signin_Link_Body_PlainInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_link_body_plain = /** @type {((inputs?: Signin_Link_Body_PlainInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Link_Body_PlainInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_link_body_plain(inputs)
	if (locale === "he") return he_signin_link_body_plain(inputs)
	if (locale === "ur") return ur_signin_link_body_plain(inputs)
	if (locale === "es") return es_signin_link_body_plain(inputs)
	if (locale === "fr") return fr_signin_link_body_plain(inputs)
	if (locale === "de") return de_signin_link_body_plain(inputs)
	if (locale === "pt") return pt_signin_link_body_plain(inputs)
	if (locale === "hi") return hi_signin_link_body_plain(inputs)
	if (locale === "bn") return bn_signin_link_body_plain(inputs)
	return /** @type {LocalizedString} */ ("We sent a sign-in link to your email. Open it on this device.")
});